import PropTypes from 'prop-types'

import {
  Button, Form, SidebarModal,
} from '@domain-group/suit-theme'

import useBrand, { useBrandForm } from '@hooks/useBrand'

const ManageBrandSystemColoursModal = (props) => {
  const {
    brandId, callbacks, modalKey, showModal,
  } = props
  const { closeModal, updateSystemBrandColours } = callbacks

  const {
    brand,
    callbacks: { updateBrand: updateFn },
    updating,
  } = useBrand({ id: brandId })

  const {
    entityState,
    entityState: {
      colour_accent,
      colour_gradient_end,
      colour_gradient_start,
      colour_highlight,
      colour_primary,
      colour_secondary,
    },
    handlers,
  } = useBrandForm(brand)

  const brandSystemColourPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Brand System Colours Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Update System"
        titleSecondLine="Brand Colour"
      />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Primary (#)">
            <input
              name="colour_primary"
              placeholder="e.g. 000000"
              type="text"
              value={colour_primary}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Secondary (#)" marginTop="large">
            <input
              name="colour_secondary"
              placeholder="e.g. 000000"
              type="text"
              value={colour_secondary}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Highlight (#)" marginTop="large">
            <input
              name="colour_highlight"
              placeholder="e.g. 000000"
              type="text"
              value={colour_highlight}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Accent (#)" marginTop="large">
            <input
              name="colour_accent"
              placeholder="e.g. 000000"
              type="text"
              value={colour_accent}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Gradient Start (#)" marginTop="large">
            <input
              name="colour_gradient_start"
              placeholder="e.g. 000000"
              type="text"
              value={colour_gradient_start}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Gradient End (#)" marginTop="large">
            <input
              name="colour_gradient_end"
              placeholder="e.g. 000000"
              type="text"
              value={colour_gradient_end}
              {...handlers}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateSystemBrandColours(brandSystemColourPayload)}
          size="large"
        >
          Update System Brand Colour
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageBrandSystemColoursModal.propTypes = {
  brandId: PropTypes.number.isRequired,
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageBrandSystemColoursModal.defaultProps = {
  modalKey: 'ManageBrandSystemColoursModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageBrandSystemColoursModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
